import T from '../../Locale';
export const ValueTypes = [
    { value: 'value', label: T.translate('values.types.value.title'), description: T.translate('values.types.value.description'), color: 'purple' },
    { value: 'property', label: T.translate('values.types.property'), color: 'redalert' },
    { value: 'vehicle', label: T.translate('values.types.vehicle'), color: 'blue' },
    { value: 'vessel', label: T.translate('values.types.vessel'), color: 'red' },
    { value: 'saving', label: T.translate('values.types.saving'), color: 'green' },
    { value: 'pension', label: T.translate('values.types.pension'), color: 'green' },
    { value: 'insurance', label: T.translate('values.types.insurance'), color: 'orange' },
    { value: 'company', label: T.translate('values.types.company'), color: 'turquoise' }
];
export const getTypesForSelect = () => ValueTypes
    .sort((a, b) => {
    if (a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
    }
    else if (a.label.toLowerCase() < b.label.toLowerCase()) {
        return -1;
    }
    return 0;
})
    .map((definition) => {
    const value = Object.assign({}, definition);
    if (value.description) {
        value.label = `${value.label} (${value.description})`;
    }
    return value;
});
export const getType = (value) => {
    let type = null;
    ValueTypes.forEach((definition) => {
        if (definition.value === value) {
            type = definition;
        }
    });
    return type;
};
